import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetUnionDelegationServiceList } from "DelegationService/DelegationService/Domain/Responses/UnionDelegationService/GetUnionDelegationServiceList";

export async function getUnionDelegationServiceListService(data) {
    let response = await getAPIResponse("/v1/union-service-delegation-list", data);
    if (response === null) {
        return null;
    }
    let getUnionDelegationServiceList = GetUnionDelegationServiceList.createFromResponseData(response);
    return getUnionDelegationServiceList;
}